import MessageExcerpt from '@/components/LeftSidebar/ChannelThumbNail/MessageExcerpt/MessageExcerpt.vue';
export default {
    name: 'MessagePreview',
    data: function() {
        return {
        }
    },
    components: {
        MessageExcerpt
    },
    props: {
        message_doc: Object,
        title: String,
        display_close: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closePreview() {
            this.$emit('closePreview', true);
        }
    }
}
